import "./SwitchStyles.scss";

import React, { memo, useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";

interface IProps {
  onChange: (val: any) => void;
  label: string;
  disabled?: boolean;
  checked: boolean;
  switcherFirst?: boolean;
}

const Switch: React.FC<IProps> = memo(
  ({ onChange, label, disabled, checked, switcherFirst }) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
      },
      [onChange],
    );

    return (
      <Form.Check
        className={`custom-switch ${switcherFirst ? "switcher-first" : ""}`}
        type="switch"
        id="custom-switch"
        onChange={handleChange}
        label={label}
        checked={checked}
        disabled={disabled}
      />
    );
  },
);

export { Switch };
